var _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M21.81,5.29a2.784,2.784,0,0,1,.06.58",
    fill: "#165cf3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(24.28 13.14)",
    fill: "#9526dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M20.41,24.81V25.9a4.37,4.37,0,1,1-8.74,0V24.81",
    fill: "#0ee359",
    stroke: "#9526dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M24.67,11.74a7.97,7.97,0,0,0-2.05-4.68",
    fill: "rgba(255,255,255,0)",
    stroke: "#9526dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M22.62,7.06a8.179,8.179,0,0,0-2.89-1.89,1.208,1.208,0,0,1-.68-.72,3.314,3.314,0,0,0-3.01-2.56,3.293,3.293,0,0,0-3,2.56,1.235,1.235,0,0,1-.68.72c-2.28.94-5.04,2.86-5.04,8.28,0,5.91-1.24,7-2.99,9.15a1.373,1.373,0,0,0,1.18,2.22H26.59a1.376,1.376,0,0,0,1.17-2.22c-1.52-1.85-2.65-2.92-2.92-7",
    fill: "rgba(255,255,255,0)",
    stroke: "#9526dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/notification-active-icon.507b8822a4aea8e6ee31b43a15fefb1a.svg";
export { ForwardRef as ReactComponent };